import * as React from 'react';
import { SVGProps } from 'react';

const SvgAppointments = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M12.25 11H8.5v3.75h3.75V11Zm6.26-.01h-3.77v3.77h3.77v-3.77Zm6.25 0h-3.77v3.77h3.77v-3.77Zm6.25 0h-3.77v3.77h3.77v-3.77Zm-18.75 6.27H8.49v3.77h3.77v-3.77Zm6.26 1.99-2.16 1.78h-1.61v-3.77h3.77v1.99Zm-6.26 4.25H8.49v3.77h3.77V23.5Zm14.2-1.69h-6.81v6.81h6.81v-6.81Zm4.55-.78h-.96l-2.81-1.92v-1.85h3.77v3.77Z"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M11 5.18V1m17.5 4.18V1M17.03 31.04H4.75V4.77h30v26.27H28.7"
    />
    <path fill={props.fill} d="m35.5 4.02-5 5H4v-5h31.5Z" />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M23.03 33.15a8.02 8.02 0 1 0 0-16.04 8.02 8.02 0 0 0 0 16.04ZM10.17 38l7.19-7.2"
    />
  </svg>
);

export default SvgAppointments;
